import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const OIDC_PARAMS = [
  'code',
  'state',
  'session_state',
  'iss',
  'error',
  'error_code',
  'error_description',
  'error_details',
] as const;

const cleanOidcSearch = (search: string): string | null => {
  if (!search) {
    return null;
  }

  const params = new URLSearchParams(search);
  let hasChanges = false;

  OIDC_PARAMS.forEach(param => {
    if (params.has(param)) {
      params.delete(param);
      hasChanges = true;
    }
  });

  if (!hasChanges) {
    return null;
  }

  const cleaned = params.toString();
  return cleaned ? `?${cleaned}` : '';
};

export const useCleanOidcQueryParams = (enabled: boolean): void => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const hasCleanedRef = useRef(false);

  useEffect(() => {
    if (!enabled || hasCleanedRef.current) {
      return;
    }

    const cleanedSearch = cleanOidcSearch(search);
    if (cleanedSearch === null) {
      hasCleanedRef.current = true;
      return;
    }

    hasCleanedRef.current = true;
    navigate(`${pathname}${cleanedSearch}`, { replace: true });
  }, [enabled, pathname, search, navigate]);
};
